export default {
    methods: {
        handlerDeleteMany(schema, data) {
            const ids = data.map((item) => item.id)
            this.$lambda.post(`${schema}/deleteMany`, {
                ids,
            })
        },
        handlerDeleteItem(schema, id) {
            this.$gestios
                .items(schema)
                .delete(id)
                .then((res) => {
                    if (res.ok) {
                        const index = this.oldestItems.findIndex((item) => item.schema === schema)
                        this.$set(this.oldestItems, index, {
                            ...this.oldestItems[index],
                            data: this.oldestItems[index].data.filter((item) => item.id !== id),
                            totalItems: this.oldestItems[index].totalItems - 1,
                        })
                    }
                })
        },
        getParams(dateField) {
            const params = {
                page: 1,
                limit: 10,
                order: {
                    [dateField]: 'desc',
                },
                filters: [
                    {
                        _ParentOperator: 'AND',
                        _Operator: 'AND',
                        Fields: {},
                    },
                ],
            }
            const year = new Date().getFullYear() - this.yearsInThePast
            const month = new Date().getMonth() + 1
            const day = new Date().getDate()

            params.filters[0].Fields[dateField] = {
                type: 'date',
                from: `2000-01-01`,
                to: `${year}-${month}-${day}`,
            }
            return params
        },
        async getOldestItems(schema, dateField) {
            return new Promise((resolve) => {
                const params = this.getParams(dateField)
                this.$gestios
                    .items(schema)
                    .list(params)
                    .then((res) => {
                        if (res.ok) {
                            resolve(res.data)
                        } else {
                            resolve([])
                        }
                    })
            })
        },
        getNestedValue(obj, keyPath) {
            return keyPath.split('.').reduce((acc, key) => (acc ? acc[key] : undefined), obj)
        },
        async setOldestItems() {
            for (let index = 0; index < this.oldestItems.length; index++) {
                const element = this.oldestItems[index]
                const res = await this.getOldestItems(element.schema, element.dataHeads[2].key)
                this.$set(this.oldestItems, index, {
                    ...element,
                    data: res.map((item) => {
                        return {
                            id: item['_EntityId'],
                            serie: item[element.dataHeads[0].key],
                            name: this.getNestedValue(item, element.dataHeads[1].key),
                            date: item[element.dataHeads[2].key],
                        }
                    }),
                    totalItems: res.length,
                    isLoading: false,
                })
            }
        },
    },
    mounted() {
        this.setOldestItems()
    },
}
